import React from 'react'
import { observer } from 'mobx-react'
import useSettingsManager from '../hooks/use-settings-manager'

function EstimatedDelivery (props) {

  const settings_manager = useSettingsManager()
  const label = settings_manager.getOtherSettings('estimated_delivery', 'Anslået leveringstidspunkt: 4-5 Uger')
  const description = settings_manager.getOtherSettings('estimated_delivery_description', 'Vi kontrol måler altid din port inden opsætning')

  return (
    <aside className={'estimated-delivery'}>
      <div>
        <p className={'price heading'}>{label}</p>
        <p className={'label'}>{description}</p>
      </div>
    </aside>
  )
}

export default observer(EstimatedDelivery)